import excel from "./excel.svg";
import powerpoint from "./powerpoint.svg";
import word from "./word.svg";
import pdf from "./pdf.svg";
import txt from "./txt.svg";
import md from "./md.svg";
import unknown from "./unknown.svg";

const getIconByType = (
  fileType:
    | "xls"
    | "pptx"
    | "ppt"
    | "pdf"
    | "docx"
    | "doc"
    | "xlsx"
    | "txt"
    | "md"
    | "all"
    | "link"
) => {
  switch (fileType) {
    case "xls":
      return excel;
    case "xlsx":
      return excel;
    case "ppt":
      return powerpoint;
    case "pptx":
      return powerpoint;
    case "doc":
      return word;
    case "docx":
      return word;
    case "pdf":
      return pdf;
    case "txt":
      return txt;
    case "md":
      return md;
    case "link":
      return word;
    default:
      return unknown;
  }
};

export default getIconByType;
